import {
  initialState,
  Actions,
  State,
  EDIT_COMPANY_SMALL_LOGO,
  EDIT_COMPANY_SMALL_LOGO_SUCCESS,
  EDIT_COMPANY_SMALL_LOGO_ERROR,
  RESET_EDIT_COMPANY_SMALL_LOGO,
} from '../../types/company/edit-small-logo'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_COMPANY_SMALL_LOGO:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_COMPANY_SMALL_LOGO_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_COMPANY_SMALL_LOGO_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_COMPANY_SMALL_LOGO:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
